import MachineStatus from '../machines/machineStatus';
import MachineType from '../machines/machineType';
import { Box, Typography } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import '../../css/dashboardListViewData.css';

const DashboardListViewData = ({ filters, machine, regions, columnWidth }) => {

  if (!machine) {
    return (
      <Box className='dashboard_table_row'>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        {regions.length > 1 && <Box sx={{ color: '#414040', minWidth: columnWidth.region }}><Skeleton variant="text" width="100%" /></Box>}
        <Box sx={{ color: '#414040', minWidth: columnWidth.site }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.pole }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.metier }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.status }}><Skeleton variant="text" width="100%" /></Box>
        <Box sx={{ color: '#414040', minWidth: columnWidth.type }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.purchase_price, position: 'sticky', right: columnWidth.total_expenses, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
        <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.total_expenses, position: 'sticky', right: 0, backgroundColor: 'white', zIndex: 1 }}><Skeleton variant="text" width="100%" /></Box>
      </Box>
    );
  }

  return (
    <Box className='dashboard_table_row'>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#EA5E00', minWidth: columnWidth.name, maxWidth: columnWidth.name, position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography'>{machine?.name}</Typography>
      </Box>
      {regions?.length > 1 &&
        <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.region, maxWidth: columnWidth.region }}>
          <Typography className='tableBodyTypography'> {machine?.region?.name}</Typography>
        </Box>
      }
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.site, maxWidth: columnWidth.site }}>
        <Typography className='tableBodyTypography'>{machine?.site?.name}</Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.pole, maxWidth: columnWidth.pole }}>
        <Typography className='tableBodyTypography'>{machine?.pole?.name}</Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.metier, maxWidth: columnWidth.metier }}>
        <Typography className='tableBodyTypography'>{machine?.machine_metier?.map((metier) => metier.metier.name).join(" - ") || 'N/A'}</Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.status, maxWidth: columnWidth.status }}>
        <MachineStatus status={machine?.status} />
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.type, maxWidth: columnWidth.type }}>
        <MachineType type={machine?.type} />
      </Box>
      <Box className='tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.purchase_price, maxWidth: columnWidth.purchase_price, position: 'sticky', right: columnWidth.total_expenses, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography'  sx={{ textAlign: 'end' }}>{machine?.purchase_price ? `${new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(machine.purchase_price)}` : 'N/A'}</Typography>
      </Box>
      <Box className='dashboard_tableBodyCell' sx={{ color: '#414040', minWidth: columnWidth.total_expenses, maxWidth: columnWidth.total_expenses, position: 'sticky', right: 0, backgroundColor: 'white', zIndex: 1 }}>
        <Typography className='tableBodyTypography' sx={{ textAlign: 'end' }}>
          {!filters.selectedYear ? (
            (machine?.total_expenses || machine?.total_expenses === 0)
              ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(machine?.total_expenses)
              : '0,00 €'
          ) : (
            machine?.machine_expense && machine.machine_expense.length > 0
              ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(
                machine.machine_expense.reduce((sum, expense) => sum + (expense.amount || 0), 0)
              )
              : '0,00 €'
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default DashboardListViewData;